import { createClient } from "@supabase/supabase-js";

const supabaseUrl_dev = "https://sndiitvbohvjvnvmebeh.supabase.co";
const supabaseKey_dev =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNuZGlpdHZib2h2anZudm1lYmVoIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTcyMjk2NDA5MCwiZXhwIjoyMDM4NTQwMDkwfQ.-dlUKgPkcFfWEDP0HrU28UkVoxz4nhWM_TQmvY5nx-s";

const supabaseAdmin = createClient(supabaseUrl_dev, supabaseKey_dev);

export default supabaseAdmin;
